export default __webpack_public_path__ + "static/media/clip.a3260cf2.svg";